// @flow

import React, { useCallback, useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import { includes, filter, toUpper, replace, reduce } from 'lodash';

import { WebsiteDefaultPage as BaseWebsiteDefaultPage } from 'components/Page';
import { PageType, VIDEO_PLAYER } from 'Constants';
import { OriginationFees } from 'data/global/footer/legal/numbered';
import { useImages } from 'hooks';
import { Color, flex, Layout, maxWidthContainer, topBottomMargin, Width } from 'styles';
import { MarketsHero } from 'components/Content';
import { ImageLoader, Link } from 'components/Gui';
import { ModalContextActions, useModalDispatch } from 'contexts';
import axios from 'axios';

const METADATA = {
  title: 'Financial products to simplify finances, faster',
  description: `At Markets Direct, we’re transforming home equity by creating a fast, simple and transparent process to bring you closer to your financial goals. We'll show you how to use home equity to consolidate debt, pay for home improvement or fund your retirement. It's quick and easy. Let’s unlock the potential of your largest asset.`,
};

const PAGE_TYPE = {
  product: PageType.PRODUCT.NONE,
};

const WebsiteDefaultPage = styled(BaseWebsiteDefaultPage)`
  width: 100% !important;
`;

type Quote = {
  pair: string,
  bid: string,
  ask: string,
  dailyHigh: string,
  dailyLow: string,
  transactionStamp: string,
  percentageRateChange: string,
};

const SWAPS_URL = 'https://secure.fxdd.com/fileadmin/setup/libraries/proxy/jason.php';
const SPREADS_URL = 'https://www.fxdd.com/api/price-feed/clear';

const Equities = [
  'AA',
  'AAL',
  'AAP',
  'AAPL',
  'ABBV',
  'ABEV',
  'ABMD',
  'ABT',
  'ACB',
  'ACHN',
  'ACN',
  'ADBE',
  'ADP',
  'ADSK',
  'AEO',
  'AEP',
  'AES',
  'AFL',
  'AGNC',
  'AIG',
  'AKS',
  'ALGN',
  'ALK',
  'ALLY',
  'ALXN',
  'AM',
  'AMAT',
  'AMC',
  'AMD',
  'AMGN',
  'AMRX',
  'AMT',
  'AMTD',
  'AMZN',
  'ANET',
  'ANF',
  'ANGI',
  'ANTM',
  'AOK',
  'APA',
  'APPS',
  'AR',
  'ARMK',
  'ARR',
  'ATUS',
  'ATVI',
  'AU',
  'AUY',
  'AVGO',
  'AVP',
  'AWK',
  'AXP',
  'AYX',
  'AZO',
  'BA',
  'BABA',
  'BAC',
  'BB',
  'BBBY',
  'BBY',
  'BEP',
  'BIDU',
  'BIIB',
  'BILI',
  'BJ',
  'BKNG',
  'BLK',
  'BMY',
  'BND',
  'BNDX',
  'BP',
  'BRK.A',
  'BRK.B',
  'BSV',
  'BSX',
  'BTG',
  'BTI',
  'BURL',
  'BX',
  'BYND',
  'BZUN',
  'C',
  'CAG',
  'CAT',
  'CBL',
  'CCEP',
  'CCL',
  'CDEV',
  'CGC',
  'CHGG',
  'CHK',
  'CHTR',
  'CHWY',
  'CI',
  'CL',
  'CLDR',
  'CLNY',
  'CLX',
  'CMCSA',
  'CME',
  'CMG',
  'CNK',
  'CNP',
  'COF',
  'COG',
  'COP',
  'COST',
  'COUP',
  'CPB',
  'CPE',
  'CRC',
  'CRM',
  'CRON',
  'CRWD',
  'CSCO',
  'CTL',
  'CTSH',
  'CTXS',
  'CVNA',
  'CVS',
  'CVX',
  'CYH',
  'CZR',
  'D',
  'DAL',
  'DBX',
  'DD',
  'DDOG',
  'DE',
  'DECK',
  'DELL',
  'DFS',
  'DG',
  'DGAZ',
  'DGX',
  'DHR',
  'DIA',
  'DIS',
  'DISH',
  'DKS',
  'DLTR',
  'DNKN',
  'DNR',
  'DOCU',
  'DOW',
  'DPZ',
  'DRI',
  'DUK',
  'DVN',
  'EA',
  'EB',
  'EBAY',
  'EGO',
  'EHTH',
  'EL',
  'EMB',
  'ERI',
  'ET',
  'ETFC',
  'ETSY',
  'EWZ',
  'EXPE',
  'F',
  'FANG',
  'FB',
  'FCAU',
  'FDX',
  'FIT',
  'FIVE',
  'FL',
  'FLOT',
  'FOXA',
  'FSLR',
  'FTNT',
  'FXI',
  'GD',
  'GDDY',
  'GDX',
  'GDXJ',
  'GE',
  'GH',
  'GILD',
  'GIS',
  'GLD',
  'GLW',
  'GM',
  'GME',
  'GOLD',
  'GOOG',
  'GOOGL',
  'GPN',
  'GPOR',
  'GPRO',
  'GPS',
  'GRPN',
  'GRUB',
  'GS',
  'GSK',
  'GT',
  'HAL',
  'HAS',
  'HBI',
  'HD',
  'HES',
  'HEXO',
  'HGV',
  'HIMX',
  'HLF',
  'HLT',
  'HMY',
  'HOG',
  'HOME',
  'HON',
  'HPE',
  'HPQ',
  'HRB',
  'HRL',
  'HSY',
  'HTZ',
  'HUBS',
  'HUM',
  'I',
  'IAC',
  'IAU',
  'IBM',
  'IEF',
  'ILMN',
  'IMGN',
  'INFY',
  'INO',
  'INTC',
  'INTU',
  'IQ',
  'IRBT',
  'IRM',
  'ISRG',
  'IVV',
  'IWM',
  'JBLU',
  'JCP',
  'JD',
  'JMIA',
  'JNJ',
  'JNUG',
  'JPM',
  'JWN',
  'K',
  'KBH',
  'KDP',
  'KHC',
  'KMB',
  'KMI',
  'KMX',
  'KO',
  'KOS',
  'KR',
  'KSS',
  'LB',
  'LEN',
  'LH',
  'LHX',
  'LITE',
  'LK',
  'LLY',
  'LMT',
  'LOW',
  'LPI',
  'LPL',
  'LRCX',
  'LULU',
  'LUV',
  'LVGO',
  'LVS',
  'LXRX',
  'LYFT',
  'LYV',
  'M',
  'MA',
  'MAR',
  'MAT',
  'MCD',
  'MCHP',
  'MDB',
  'MDLZ',
  'MDT',
  'MELI',
  'MFA',
  'MGI',
  'MGM',
  'MJ',
  'MMM',
  'MNST',
  'MO',
  'MOMO',
  'MPC',
  'MRK',
  'MRO',
  'MRVL',
  'MSFT',
  'MSI',
  'MTCH',
  'MU',
  'MYL',
  'NBIX',
  'NBL',
  'NCLH',
  'NDAQ',
  'NEE',
  'NEM',
  'NET',
  'NFLX',
  'NIO',
  'NKE',
  'NLOK',
  'NOC',
  'NOW',
  'NTES',
  'NTNX',
  'NVCR',
  'NVDA',
  'NYT',
  'O',
  'OAS',
  'ODFL',
  'ODP',
  'OKTA',
  'OLLI',
  'OPK',
  'ORCL',
  'OSTK',
  'OVV',
  'OXY',
  'PAGS',
  'PANW',
  'PBR',
  'PCG',
  'PDD',
  'PENN',
  'PEP',
  'PFE',
  'PG',
  'PGR',
  'PINS',
  'PLCE',
  'PLNT',
  'PLUG',
  'PM',
  'PSA',
  'PSTG',
  'PSX',
  'PTON',
  'PYPL',
  'QCOM',
  'QD',
  'QQQ',
  'RACE',
  'RCL',
  'REGI',
  'REGN',
  'RH',
  'RL',
  'RNG',
  'ROKU',
  'ROST',
  'RTN',
  'S',
  'SAM',
  'SAVE',
  'SBUX',
  'SCHW',
  'SDC',
  'SEAS',
  'SFIX',
  'SHAK',
  'SHOP',
  'SHV',
  'SHW',
  'SHYG',
  'SIRI',
  'SIX',
  'SKT',
  'SKX',
  'SLB',
  'SLV',
  'SMAR',
  'SNAP',
  'SNE',
  'SO',
  'SPCE',
  'SPG',
  'SPGI',
  'SPLK',
  'SPLV',
  'SPOT',
  'SPWR',
  'SPXU',
  'SPY',
  'SQ',
  'SQQQ',
  'STNE',
  'STZ',
  'SUB',
  'SWKS',
  'SYF',
  'SYY',
  'T',
  'TDOC',
  'TEAM',
  'TER',
  'TEVA',
  'TGT',
  'TIF',
  'TJX',
  'TLRY',
  'TLT',
  'TM',
  'TME',
  'TMO',
  'TMUS',
  'TOL',
  'TQQQ',
  'TREE',
  'TRIP',
  'TSLA',
  'TSM',
  'TSN',
  'TTD',
  'TTWO',
  'TVIX',
  'TWLO',
  'TWOU',
  'TWTR',
  'TXN',
  'TXRH',
  'UAA',
  'UAL',
  'UBER',
  'UGAZ',
  'ULTA',
  'UMC',
  'UNH',
  'UNP',
  'UPS',
  'USFD',
  'USO',
  'UTX',
  'UUP',
  'UVXY',
  'V',
  'VCIT',
  'VEA',
  'VGT',
  'VIAC',
  'VIXY',
  'VLO',
  'VMW',
  'VNQ',
  'VOO',
  'VRTX',
  'VTEB',
  'VTI',
  'VTIP',
  'VWO',
  'VXF',
  'VXUS',
  'VXX',
  'VZ',
  'W',
  'WB',
  'WBA',
  'WDAY',
  'WDC',
  'WFC',
  'WH',
  'WIX',
  'WLL',
  'WM',
  'WMT',
  'WORK',
  'WU',
  'WW',
  'WWE',
  'WYNN',
  'X',
  'XLE',
  'XLK',
  'XLNX',
  'XNET',
  'XOM',
  'XOP',
  'XP',
  'YRD',
  'YUM',
  'YUMC',
  'Z',
  'ZEN',
  'ZM',
  'ZNGA',
  'ZNH',
  'ZS',
];

let LEVERAGES = {
  '#FB': '5:1',
  '#BAC': '5:1',
  '#AAPL': '5:1',
  '#AMZN': '5:1',
  '#BABA': '5:1',
  '#BIDU': '5:1',
  '#NFLX': '5:1',
  '#TSLA': '5:1',
  '#TWTR': '5:1',
  '#GOOGL': '5:1',
  AUS200: '20:1',
  'CHN.50': '10:1',
  COPPER: '10:1',
  'ESP.35': '10:1',
  'FRA.40': '20:1',
  'GER.30': '20:1',
  'HKG.33': '10:1',
  JPN225: '20:1',
  NAS100: '20:1',
  NATGAS: '10:1',
  SPX500: '20:1',
  'UK.100': '20:1',
  'UK.OIL': '10:1',
  'USA.30': '20:1',
  'AUD/CAD': '20:1',
  'AUD/CHF': '20:1',
  'AUD/JPY': '20:1',
  'AUD/NZD': '20:1',
  'AUD/USD': '20:1',
  'BTC/EUR': '2:1',
  'BTC/JPY': '2:1',
  'BTC/USD': '2:1',
  'CAD/CHF': '30:1',
  'CAD/JPY': '30:1',
  'CHF/JPY': '30:1',
  'ETH/USD': '2:1',
  'EUR/AUD': '20:1',
  'EUR/CAD': '30:1',
  'EUR/CHF': '30:1',
  'EUR/DKK': '2:1',
  'EUR/GBP': '30:1',
  'EUR/HUF': '20:1',
  'EUR/JPY': '30:1',
  'EUR/MXN': '5:1',
  'EUR/NOK': '20:1',
  'EUR/NZD': '20:1',
  'EUR/PLN': '20:1',
  'EUR/SEK': '20:1',
  'EUR/TRY': '2:1',
  'EUR/USD': '30:1',
  'EUR/ZAR': '20:1',
  'GBP/AUD': '20:1',
  'GBP/CAD': '30:1',
  'GBP/CHF': '30:1',
  'GBP/JPY': '30:1',
  'GBP/NZD': '20:1',
  'GBP/USD': '30:1',
  'GBP/ZAR': '20:1',
  'LTC/USD': '2:1',
  'NOK/JPY': '20:1',
  'NOK/SEK': '20:1',
  'NZD/CAD': '20:1',
  'NZD/CHF': '20:1',
  'NZD/JPY': '20:1',
  'NZD/USD': '20:1',
  'OIL/USD': '10:1',
  'SGD/JPY': '20:1',
  'TRY/JPY': '2:1',
  'USD/CAD': '30:1',
  'USD/CHF': '30:1',
  'USD/CNH': '2:1',
  'USD/DKK': '2:1',
  'USD/HKD': '2:1',
  'USD/HUF': '20:1',
  'USD/JPY': '30:1',
  'USD/MXN': '5:1',
  'USD/NOK': '20:1',
  'USD/PLN': '20:1',
  'USD/RUB': '20:1',
  'USD/SEK': '20:1',
  'USD/SGD': '20:1',
  'USD/TRY': '2:1',
  'USD/ZAR': '20:1',
  'XAG/EUR': '10:1',
  'XAG/USD': '10:1',
  'XAU/EUR': '20:1',
  'XAU/USD': '20:1',
  'XPD/USD': '10:1',
  'XPT/USD': '10:1',
  'XRP/USD': '2:1',
  'ZAR/JPY': '20:1',
};

let INSTRUMENTS = {
  forex: [
    'USD/JPY',
    'EUR/USD',
    'GBP/USD',
    'USD/CHF',
    'USD/CAD',
    'AUD/USD',
    'NZD/USD',
    'EUR/GBP',
    'EUR/JPY',
    'EUR/CHF',
    'EUR/AUD',
    'EUR/CAD',
    'EUR/NZD',
    'GBP/JPY',
    'GBP/CHF',
    'GBP/CAD',
    'GBP/AUD',
    'GBP/NZD',
    'NZD/JPY',
    'NZD/CAD',
    'NZD/CHF',
    'AUD/JPY',
    'AUD/CAD',
    'AUD/CHF',
    'AUD/NZD',
    'CAD/JPY',
    'CAD/CHF',
    'CHF/JPY',
    'USD/MXN',
    'EUR/MXN',
    'USD/PLN',
    'EUR/PLN',
    'USD/TRY',
    'EUR/TRY',
    'TRY/JPY',
    'USD/CNH',
    'USD/HKD',
    'USD/SGD',
    'SGD/JPY',
    'USD/HUF',
    'EUR/HUF',
    'USD/ZAR',
    'EUR/ZAR',
    'GBP/ZAR',
    'ZAR/JPY',
    'USD/SEK',
    'EUR/SEK',
    'USD/NOK',
    'EUR/NOK',
    'USD/DKK',
    'EUR/DKK',
    'NOK/SEK',
    'NOK/JPY',
    'USD/RUB',
  ],
  metals: ['COPPER', 'XAU/USD', 'XAG/USD', 'XAU/EUR', 'XAG/EUR', 'XPT/USD', 'XPD/USD'],
  stocks: ['#AAPL', '#FB', '#AMZN', '#NFLX', '#TSLA', '#GOOGL', '#BABA', '#TWTR', '#BAC', '#BIDU'],
  indices: ['ESP.35', 'GER.30', 'FRA.40', 'UK.100', 'AUS200', 'JPN225', 'HKG.33', 'USA.30', 'NAS100', 'SPX500', 'CHN.50'],
  energies: ['OIL/USD', 'NATGAS', 'UK.OIL'],
};

type Change = 'up' | 'down' | 'none';

type ParsedSpread = {
  id: string,
  bid: string,
  ask: string,
  bidNum: number,
  askNum: number,
  dailyHigh: string,
  dailyLow: string,
  bidChange: Change,
  askChange: Change,
  spread: string,
  swapLong: string,
  swapShort: string,
  leverage: string,
};

const SHIFT: any = {
  'XPT/USD': 1,
  'XPD/USD': 2,
  'EUR/ZAR': 3,
  'USD/ZAR': 3,
  'GBP/ZAR': 3,
  'USD/RUB': 1,
  JPN225: 1,
  'HKG.33': 1,
  'CHN.50': 1,
};

function updateSwaps(swaps) {
  return reduce(
    swaps,
    (acc: any, swap) => {
      let key: string = swap[0].replace('/', '/');
      acc[key] = {
        long: swap[1],
        short: swap[2],
      };
      return acc;
    },
    {}
  );
}

let swaps = {};

function parseQuote(quote: any, index: number, spreads: ParsedSpread[]): ParsedSpread {
  let bidChange: Change = 'none';
  let askChange: Change = 'none';
  let id: string = replace(quote.pair, '/', '/');
  let bidNum: number;
  let askNum: number;
  let spread: string;
  let override: boolean = false;
  bidNum = parseInt(replace(replace(quote.bid, ',', ''), '.', ''));
  askNum = parseInt(replace(replace(quote.ask, ',', ''), '.', ''));
  const old = spreads.find((inst) => inst.id === id);
  if (old) {
    if (bidNum !== old.bidNum) {
      bidChange = bidNum > old.bidNum ? 'up' : 'down';
    }
    if (askNum !== old.askNum) {
      askChange = askNum > old.askNum ? 'up' : 'down';
    }
  }
  spread = (askNum - bidNum).toString();
  if (includes(id, 'MXN')) {
    spread = `${spread.slice(0, spread.length - 1)}.${spread.slice(spread.length - 1)}`;
    override = true;
  }
  if (!override) {
    if (spread.length === 1) spread = '0.' + spread;
    else spread = spread.substring(0, spread.length - 1) + '.' + spread.substring(spread.length - 1, spread.length);
    if (spread.length === 2 && spread.indexOf('.') === -1) {
      spread = `${spread.slice(0, 1)}.${spread.slice(1, 2)}`;
    }
    if (spread.length === 3 && spread.indexOf('.') === -1) {
      spread = `${spread.slice(0, 2)}.${spread.slice(2, 3)}`;
    }
    if (spread.length === 4 && spread.indexOf('.') === -1) {
      spread = `${spread.slice(0, 2)}.${spread.slice(2, 4)}`;
    }
    if (spread.length >= 4) {
      if (spread.indexOf('.') !== 1) {
        spread = spread.replace('.', '');
        spread = `${spread.slice(0, 2)}.${spread.slice(2)}`;
      }
    }
    if (SHIFT[id]) {
      if (SHIFT[id] === 1) {
        spread = spread.replace('.', '');
        if (spread.length === 4) {
          spread = `${spread.slice(0, 3)}.${spread.slice(3)}`;
        }
      }
      if (SHIFT[id] === 2) {
        spread = spread.replace('.', '').slice(0, spread.length - 2);
      }
      if (SHIFT[id] === 3) {
        spread = spread.replace('.', '').slice(0, spread.length - 1);
      }
      if (spread.indexOf('.') === -1) {
        spread = `${spread}.0`;
      }
    }
  }
  spread = spread.replace('.00', '.0');
  return {
    id: id,
    bid: quote.bid,
    ask: quote.ask,
    bidNum: bidNum,
    askNum: askNum,
    dailyHigh: quote.dailyHigh,
    dailyLow: quote.dailyLow,
    bidChange: bidChange,
    askChange: askChange,
    spread: spread,
    swapLong: (swaps[id] && swaps[id].long) || '--',
    swapShort: (swaps[id] && swaps[id].short) || '--',
    leverage: LEVERAGES ? LEVERAGES[id] : '',
  };
}

const Wrapper = styled.div`
  width: 100%;
  ${flex()};
  flex-direction: column;
  ${topBottomMargin([Layout.NAV_HEIGHT_MOBILE, 0], [Layout.NAV_HEIGHT_DESKTOP, 0], [Layout.NAV_HEIGHT_DESKTOP, 0])};
  background: white;
`;

const Data = {
  fxFees: {
    type: 'fxFees',
    blurb: 'Commissions on single stocks cfds  - we charge $8 per standard lot per side ($16 R/T)  std lot = 100,000',
  },
};

const DataContainer = styled.div`
  padding: 48px 0;
  max-width: 100%;
  width: 700px;
  h2 {
    margin-bottom: 24px;
  }
  div.links {
    ${flex('flex-start', 'flex-start')};
  }
  div.row {
    ${flex('flex-start', 'flex-start')};

    &:nth-child(even) {
      background: ${Color.GREY_LIGHT};
    }

    > div {
      width: 180px;
      padding: 12px;
      box-sizing: border-box;
    }
  }
  div.header {
    margin-top: 24px;
    > div {
      font-weight: 700;
    }
  }
`;

const TheData = [
  {
    name: 'Futures Pro Fee',
    real: '$115 Per Exchange Per Month',
    delayed: '$7 Per Exchange Per Month',
  },
  {
    name: 'Futures Non-Pro Fee',
    real: '$11.00 per exchange quadrant, capped at $33.00 per month',
    delayed: 'Free',
  },
  {
    name: 'Equity Pro Fees',
    real: '$27 Per Month',
  },
  {
    name: 'Equity Non-Pro Fees',
    real: '$1 Per Month',
  },
  {
    name: 'CQG User Fee',
    real: '$25 Per month per User',
  },
  {
    name: 'Wire Transfer Fee',
    real:
      '$30.00 Wires, return wires and currency conversions, reproduction of an account statement and electronic trading log for audit purposes.',
  },
  {
    name: 'Margin and/or Daily loss limit Liquidation',
    real: '$25 per contract',
  },
  {
    name: 'Additional Trader Fee',
    real: '$25 per month',
  },
  {
    name: 'Futures Regulatory Fee',
    real: '$0.02 per contract',
  },
];

const LinkButton = styled(Link)`
  width: 180px;
  padding: 12px 0;
  border: 1px solid ${Color.MARKETS_RED};
  border-right: none;
  color: ${({ active }) => (active ? Color.WHITE : Color.BLACK_SOUL)};
  background: ${({ active }) => (active ? Color.MARKETS_RED : 'none')};

  &:last-of-type {
    border: 1px solid ${Color.MARKETS_RED};
  }
`;

const Item = styled.div`
  ${({ up }) => up && `color: blue`};
  ${({ down }) => down && `color: red`};
`;

let spreads = [];

const PageContainer = ({ data }: { data: any }) => {
  const getImage = useImages(data);
  return (
    <WebsiteDefaultPage
      page={PAGE_TYPE}
      metaData={{
        ...METADATA,
        image: getImage('glossary'),
      }}
      footerLegal={{
        numbered: OriginationFees,
      }}>
      <Wrapper>
        <MarketsHero
          title="GLOSSARY"
          blurb="Useful terms and information"
          image={{
            name: 'glossary',
          }}
          images={data}
        />
        <DataContainer>
          <h2>Coming Soon</h2>
        </DataContainer>
      </Wrapper>
    </WebsiteDefaultPage>
  );
};

export default PageContainer;

export const query = graphql`
  query {
    imageToWebP: allFile(filter: { relativeDirectory: { in: ["pages/team", "pages/glossary"] }, extension: { nin: ["svg", "gif"] } }) {
      edges {
        node {
          ...ImageToWebP
        }
      }
    }
    otherImage: allFile(filter: { relativeDirectory: { eq: "pages/team" }, extension: { in: ["svg", "gif"] } }) {
      edges {
        node {
          ...OtherImage
        }
      }
    }
  }
`;
